import { render, staticRenderFns } from "./Deck.vue?vue&type=template&id=223ce6ea&scoped=true&"
import script from "./Deck.vue?vue&type=script&lang=js&"
export * from "./Deck.vue?vue&type=script&lang=js&"
import style0 from "./Deck.vue?vue&type=style&index=0&id=223ce6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ce6ea",
  null
  
)

export default component.exports